import { ElMessage } from 'element-plus'
export const handleCopySuccess = () => {
  ElMessage({
    type: 'success',
    message: '已复制'
  })
}


/**
 * 扁平化：将具有层级递进关系结构的 tree 数据扁平化
 * 
 * @param treeList 有层级递进关系结构的 tree 数据
 * @param flatList 用于接收扁平化结果的变量
 * @returns {*} 返回扁平化结果
 */
export const treeToFlat = (treeList, flatList) => {
  treeList.forEach(e => {
    flatList.push(e)
    // 递归：有条件的自己调用自己，条件是 e.children.length 为真
    if (e.children && e.children.length) {
      treeToFlat(e.children, flatList)
    }
  })
  return flatList
}

// async/await的trycatch封装
export const awaitCatch = (promise) => {
  return promise
      .then(data => [null, data])
      .catch(err => [err, null])
}

// 随机串
export const randomID = () => Math.random().toString().replace('.', '')

// 数据1000->1k
export const numBeauty = (num) => {
  const _num = Number(num)
  if (_num >= 1000) {
    return Math.floor(_num/100)/10 + 'K+'
  }
  return _num
}
// 数据百位取整
export const numBeautyHundred = (num) => {
  const _num = Number(num)
  if (_num >= 100) {
    // return (Math.floor(_num/100)*100).toLocaleString()
    return Math.floor(_num/100)*100
  }
  return _num
}

export function debounce(cb, delay) {
  let timer = null
  return function (self, ...args) {
    const _this = self
    clearTimeout(timer)
    timer = setTimeout(() => {
      cb.apply(_this, args)
    }, delay)
  }
}

export function isJSON(str) {
  let bool = false
  try {
    JSON.parse(str)
    bool = true
  } catch {
    bool = false
  }
  return bool;
}

/**
 * 把值JSON.parse后赋值，失败用默认值
 * @param {*} value 
 * @param {*} defaultVal
 */ 
export function setJSONParse(value, defaultVal) {
  if (!value) return defaultVal
  try {
    return JSON.parse(value)
  } catch (err) {
    return defaultVal
  }
}

/**
 * 把值JSON.stringify后赋值，失败用默认值
 * @param {*} value 
 * @param {*} defaultVal
 */ 
export function setJSONStringify(value, defaultVal = '') {
  if (!value) return defaultVal
  try {
    return JSON.stringify(value)
  } catch (err) {
    return defaultVal
  }
}

/**
 * 把值JSON.stringify后赋值，失败用默认值，space=空格数
 * @param {*} value 
 * @param {*} defaultVal
 * @param {*} space
 */ 
export function setJSONStringifyFormat(value, defaultVal, space = 4) {
  if (!value) return defaultVal
  try {
    return JSON.stringify(value, null, space)
  } catch (err) {
    return defaultVal
  }
}

/**
 * 计算节点的距离目标parentDom的offsetTop
 * @param {*} dom 目标dom
 * @param {*} parentDom 目标祖先dom
 * @param {*} offsetHeight 手动偏移量
 * @returns 
 */
export function getDomOffsetTop(dom, parentDom, offsetHeight = 0) {
  let height = dom?.offsetTop, parent = dom?.offsetParent
  // parent !== null
  while (parent !== parentDom) {
    height += parent.offsetTop
    parent = parent.offsetParent
  }
  height += offsetHeight
  return height
}

/**
 * 传入blob下载文件
 * @param {Blob} blob blob对象
 */
export function downloadFromBlob(blob, name) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// 换行符转义
export const translateLineBreak = (text) => {
  if (typeof text === 'string') {
    return text.replace(/\n/g, '<br>');
  }
  if (!text) {
    return '';
  }
  return text;
};